const env_config = {
  apiBaseAdmin: process.env.REACT_APP_API_BASE_ECOM,
  apiBaseMap: process.env.REACT_APP_API_BASE_MAP,
  apiBaseAdmcsm: process.env.REACT_APP_API_BASE_MAP,
  apiBaseChat: process.env.REACT_APP_API_BASE_CHAT,
  apiBaseThietBi: process.env.REACT_APP_API_BASE_THIETBI,
  serviceSocket: process.env.REACT_APP_SOCKET_SERVICE,
  apiCameraStreaming: process.env.REACT_APP_API_CAMERA_STREAMING,
  apiTruckCameraStreaming: process.env.REACT_APP_API_TRUCK_CAMERA_STREAMING,
  keySocket: process.env.REACT_APP_KEY_SOCKET_SERVICE,
  apiBaseTracker: process.env.REACT_APP_API_BASE_TRACKER,
  apiBaseSms: process.env.REACT_APP_API_BASE_SMS,
  apiBaseTripod: process.env.REACT_APP_API_BASE_TRIPOD,
  apiBaseBarrier: process.env.REACT_APP_API_BASE_BARRIER,
  apiBaseDvr: process.env.REACT_APP_API_BASE_DVR,
  apiBaseWms: process.env.REACT_APP_API_BASE_WMS,
  apiIotCamera: `${process.env.REACT_APP_API_BASE_MAP}/camera-v2`,
  positionJob: {
    B2C: "34",
  },
  groupId: {
    CSKH: "4",
    IT: "15",
  },
  isDevDependencies: false,
  ghtkID: {
    authn: {
      url: process.env.REACT_APP_AUTHN_URL,
    },
    oidc: {
      clientId: process.env.REACT_APP_OIDC_CLIENTID,
      issuer: process.env.REACT_APP_OIDC_ISSUER,
      redirectUri: process.env.REACT_APP_OIDC_REDIRECTURI,
      scopes: ["openid"],
      pkce: true,
      isAuthzBackground: false,
      authnUrl: process.env.REACT_APP_OIDC_AUTHNURL,
      logoutBackUrl: process.env.REACT_APP_OIDC_LOGOUTBACKURL,
    },
    resourceServer: {
      accountsUrl: "http://localhost:9000/api/messages",
    },
  },
};

export default env_config;
